/*
 * @Author: hfxie
 * @Date: 2024-02-17 14:37:30
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-02-20 11:02:41
 * @Description: 常量名
 */


/* 图标列表 */
const ICON_LIST = [
  "el-icon-s-flag", // 旗子-项目 0
  "el-icon-folder-opened", // 文件夹-汇总 1
  "el-icon-star-on", // 实心星星-里程碑任务 2
  "el-icon-star-off", // 空心星星-重要任务 3
  "el-icon-warning", // 实心感叹号-高风险任务 4
  "el-icon-warning-outline", // 空心感叹号-低风险任务 5
  "el-icon-paperclip", // 回形针-普通任务(资源图标 6)
  "el-icon-document", // 书本-普通任务 7(任务这边普通不设图标为 -1)
  "el-icon-sunrise-1", // 早班 8
  "el-icon-sunny", // 午班 9
  "el-icon-moon", // 晚班 10
  /* 苍穹图标 11 - 16 */
  "kdfont kdfont-xiangmu15", // 项目 11
  "kdfont kdfont-zuzhi12", // 组织 12
  "kdfont kdfont-wenjianjia5", // 文件夹 13
  "kdfont kdfont-gongzuodigao2", // 工作底稿 14
  "kdfont kdfont-qi128", // 旗 15
  "kdfont kdfont-shuqian", // 书签 16 iconcool
];

const CONSTNAME = {
  ICON_LIST,
  
};

export default CONSTNAME;
